(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var menuButton = document.querySelector('.header__menu');
    var mobileNav = document.getElementById('MobileNav');
    if (menuButton && mobileNav) {
      menuButton.addEventListener('click', function () {
        var open = menuButton.getAttribute('aria-expanded') === 'true';
        menuButton.setAttribute('aria-expanded', String(!open));
        mobileNav.hidden = open;
      });
    }

    var gallery = document.querySelector('[data-product-gallery]');
    var mainImage = gallery && gallery.querySelector('[data-main-product-image]');
    var thumbRail = gallery && gallery.querySelector('.product-gallery__thumbs');
    var galleryThumbs = gallery ? Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-thumb]')) : [];
    var activeGalleryIndex = galleryThumbs.findIndex(function (button) {
      return button.classList.contains('is-active');
    });
    var suppressThumbClick = false;

    function imageKey(url) {
      if (!url) return '';
      try {
        return new URL(url, document.baseURI).pathname;
      } catch (error) {
        return String(url).split('?')[0];
      }
    }

    function setActiveGalleryImage(index, options) {
      if (!mainImage || !galleryThumbs.length) return;
      options = options || {};
      activeGalleryIndex = (index + galleryThumbs.length) % galleryThumbs.length;
      var activeThumb = galleryThumbs[activeGalleryIndex];
      var nextSource = activeThumb.getAttribute('data-image');
      var nextAlt = activeThumb.getAttribute('data-alt') || mainImage.alt;

      galleryThumbs.forEach(function (button, buttonIndex) {
        var isActive = buttonIndex === activeGalleryIndex;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-current', String(isActive));
      });

      if (nextSource && imageKey(mainImage.src) !== imageKey(nextSource)) {
        mainImage.classList.add('is-changing');
        mainImage.src = nextSource;
        mainImage.alt = nextAlt;
        mainImage.addEventListener('load', function () {
          mainImage.classList.remove('is-changing');
        }, { once: true });
        window.setTimeout(function () {
          mainImage.classList.remove('is-changing');
        }, 350);
      }

      if (options.scroll !== false) {
        activeThumb.scrollIntoView({
          behavior: options.instant ? 'auto' : 'smooth',
          block: 'nearest',
          inline: 'center'
        });
      }
    }

    if (galleryThumbs.length) {
      if (activeGalleryIndex < 0) activeGalleryIndex = 0;
      setActiveGalleryImage(activeGalleryIndex, { scroll: false });

      galleryThumbs.forEach(function (button, buttonIndex) {
        button.addEventListener('click', function () {
          if (suppressThumbClick) return;
          setActiveGalleryImage(buttonIndex);
        });
      });

      var previousButton = gallery.querySelector('[data-gallery-prev]');
      var nextButton = gallery.querySelector('[data-gallery-next]');
      if (previousButton) {
        previousButton.addEventListener('click', function () {
          setActiveGalleryImage(activeGalleryIndex - 1);
        });
      }
      if (nextButton) {
        nextButton.addEventListener('click', function () {
          setActiveGalleryImage(activeGalleryIndex + 1);
        });
      }

      if (thumbRail) {
        thumbRail.addEventListener('keydown', function (event) {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          setActiveGalleryImage(activeGalleryIndex + (event.key === 'ArrowRight' ? 1 : -1));
          galleryThumbs[activeGalleryIndex].focus();
        });

        thumbRail.addEventListener('wheel', function (event) {
          if (Math.abs(event.deltaY) <= Math.abs(event.deltaX)) return;
          event.preventDefault();
          thumbRail.scrollLeft += event.deltaY;
        }, { passive: false });

        var railPointerDown = false;
        var railStartX = 0;
        var railStartScroll = 0;
        thumbRail.addEventListener('pointerdown', function (event) {
          if (event.pointerType === 'mouse' && event.button !== 0) return;
          railPointerDown = true;
          suppressThumbClick = false;
          railStartX = event.clientX;
          railStartScroll = thumbRail.scrollLeft;
        });
        thumbRail.addEventListener('pointermove', function (event) {
          if (!railPointerDown) return;
          var distance = event.clientX - railStartX;
          if (Math.abs(distance) > 4 && !suppressThumbClick) {
            suppressThumbClick = true;
            thumbRail.setPointerCapture(event.pointerId);
            thumbRail.classList.add('is-dragging');
          }
          if (!suppressThumbClick) return;
          thumbRail.scrollLeft = railStartScroll - distance;
        });
        function releaseRailPointer(event) {
          if (!railPointerDown) return;
          railPointerDown = false;
          thumbRail.classList.remove('is-dragging');
          if (thumbRail.hasPointerCapture(event.pointerId)) thumbRail.releasePointerCapture(event.pointerId);
          window.setTimeout(function () { suppressThumbClick = false; }, 0);
        }
        thumbRail.addEventListener('pointerup', releaseRailPointer);
        thumbRail.addEventListener('pointercancel', releaseRailPointer);
      }

      if (mainImage) {
        var swipeStartX = 0;
        var swipeStartY = 0;
        mainImage.addEventListener('touchstart', function (event) {
          var touch = event.changedTouches[0];
          swipeStartX = touch.clientX;
          swipeStartY = touch.clientY;
        }, { passive: true });
        mainImage.addEventListener('touchend', function (event) {
          var touch = event.changedTouches[0];
          var deltaX = touch.clientX - swipeStartX;
          var deltaY = touch.clientY - swipeStartY;
          if (Math.abs(deltaX) < 45 || Math.abs(deltaX) <= Math.abs(deltaY)) return;
          setActiveGalleryImage(activeGalleryIndex + (deltaX < 0 ? 1 : -1));
        }, { passive: true });
      }
    }

    var variantCards = document.querySelectorAll('[data-variant-card]');
    variantCards.forEach(function (card) {
      card.addEventListener('click', function () {
        var radio = card.querySelector('input[type="radio"]');
        if (radio && !radio.disabled) radio.checked = true;
        variantCards.forEach(function (item) { item.classList.remove('is-selected'); });
        card.classList.add('is-selected');
        var price = document.querySelector('[data-product-price]');
        var compare = document.querySelector('[data-product-compare]');
        if (price) price.textContent = card.getAttribute('data-price');
        if (compare) {
          compare.textContent = card.getAttribute('data-compare') || '';
          compare.hidden = !card.getAttribute('data-compare');
        }
        var variantImage = card.getAttribute('data-image');
        if (mainImage && variantImage) {
          var matchingThumbIndex = galleryThumbs.findIndex(function (button) {
            return imageKey(button.getAttribute('data-image')) === imageKey(variantImage);
          });
          if (matchingThumbIndex >= 0) setActiveGalleryImage(matchingThumbIndex);
          else {
            mainImage.src = variantImage;
            mainImage.alt = card.querySelector('.bundle-card__content strong').textContent;
          }
        }
      });
    });

    document.querySelectorAll('[data-quantity-minus]').forEach(function (button) {
      button.addEventListener('click', function () {
        var input = button.parentElement.querySelector('input');
        if (input) input.value = Math.max(1, Number(input.value || 1) - 1);
      });
    });
    document.querySelectorAll('[data-quantity-plus]').forEach(function (button) {
      button.addEventListener('click', function () {
        var input = button.parentElement.querySelector('input');
        if (input) input.value = Math.max(1, Number(input.value || 1) + 1);
      });
    });

    document.querySelectorAll('[data-faq-button]').forEach(function (button) {
      button.addEventListener('click', function () {
        var item = button.closest('.faq__item');
        var panel = item && item.querySelector('.faq__answer');
        var open = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', String(!open));
        if (panel) panel.hidden = open;
      });
    });

    var delivery = document.querySelector('[data-delivery-dates]');
    if (delivery) {
      var start = new Date();
      var end = new Date();
      start.setDate(start.getDate() + 7);
      end.setDate(end.getDate() + 14);
      var options = { month: 'short', day: 'numeric' };
      delivery.textContent = start.toLocaleDateString('en-US', options) + '–' + end.toLocaleDateString('en-US', options);
    }
  });
})();
